import React, { useState } from 'react';
import { Typography, Box, Paper, Button } from '@mui/material';

import logo from '../../assets/icon.svg';
import { useSetAtom } from 'jotai';
import { pageAtom } from '../../atoms';
import { PAGE } from '../../constant/page';
import {
  CustomImage as TopconectLogo,
  EmailForm,
} from '../../sharedComponents';
import { SendButton } from './components';

const EmailEntryPage = () => {
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const setPage = useSetAtom(pageAtom);

  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent='center'
      marginTop='80px'
    >
      <Paper
        elevation={3}
        sx={{
          width: '50%',
          maxWidth: '700px',
          paddingX: '100px',
          paddingY: '50px',
        }}
      >
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          gap='50px'
        >
          <TopconectLogo src={logo} alt='logo' width='200px' />

          <Typography variant='h6'>
            {'メールアドレスを入力してください'}
          </Typography>

          <EmailForm
            email={email}
            setEmail={setEmail}
            isEmailValid={isEmailValid}
            setIsEmailValid={setIsEmailValid}
          />

          <Box
            display={'flex'}
            justifyContent={'center'}
            columnGap={5}
            marginBottom={5}
          >
            <Button
              variant='contained'
              sx={{ width: '150px' }}
              color='inherit'
              onClick={() => {
                setPage(PAGE.LOGIN);
              }}
            >
              戻る
            </Button>
            <SendButton email={email} isEmailValid={isEmailValid} />
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default React.memo(EmailEntryPage);
